module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_purpose_office_color_green-059f9142c85558bd25f8d0bd9ceeac73.svg";